import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["HomeSubscribe"] */ "/vercel/path0/shared/components/HomeSubscribe.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/shared/components/PaginationControls.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/components/PostCard.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/shared/components/Search.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/blogs/blogs.module.css");
